import { useState } from "react";
import { supa } from "./firebase";
import ActivityIndicator from "./activityIndicator";

function ModalSelezionaProdotto({ prodotti, setVisible, aggiorna, selectedData }) {
        const [selectedProdotti, setSelectedProdotti] = useState([])
        const [loading, setLoading] = useState(false)

        //function to add a rows in promise when resolve call aggiorna() and setVisible(false)
        async function addRow() {
            setLoading(true)
            const { data, error } = await supa
                .from('venditeProdotti')
                .insert(selectedProdotti.map(item => { return { "id_prodotto": item, "data": selectedData } }))
            if (error) console.log(error)
            setLoading(false)
            aggiorna()
            setVisible(false)

        }





    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm">
            {loading && <ActivityIndicator />}
            <div className="relative w-full max-w-5xl mx-4 animate-in fade-in zoom-in duration-200">
                <div className="relative bg-white rounded-2xl shadow-2xl border border-zinc-200">
                    {/* Header */}
                    <div className="flex items-center justify-between p-6 border-b border-zinc-200">
                        <div>
                            <h3 className="text-2xl font-bold text-zinc-900">Aggiungi Prodotti</h3>
                            <p className="text-sm text-zinc-600 mt-1">Seleziona i prodotti da aggiungere alla vendita</p>
                        </div>
                        <button 
                            onClick={() => setVisible(false)} 
                            className="p-2 text-zinc-400 hover:text-zinc-600 hover:bg-zinc-100 rounded-lg transition-all"
                        >
                            <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                            </svg>
                        </button>
                    </div>

                    {/* Body */}
                    <form>
                        <div className="h-[32rem] w-full">
                            <div className="bg-zinc-50 border border-zinc-200 rounded-xl overflow-hidden mx-6 my-4 h-[calc(100%-2rem)]">
                                <table className="w-full text-left text-sm">
                                    <thead className="bg-zinc-100 sticky top-0 z-10 border-b border-zinc-200">
                                        <tr>
                                            <th className="px-4 py-3 font-semibold text-zinc-700">Prodotto</th>
                                            <th className="px-4 py-3 font-semibold text-zinc-700">Costo</th>
                                            <th className="px-4 py-3 font-semibold text-zinc-700">Prezzo Staff</th>
                                            <th className="px-4 py-3 font-semibold text-zinc-700">Prezzo Clienti</th>
                                            <th className="px-4 py-3 font-semibold text-zinc-700 text-center">Seleziona</th>
                                        </tr>
                                    </thead>
                                    <tbody className="overflow-y-auto noBar h-full">
                                        {prodotti?.map((item, index) => (
                                            <tr key={index} className="border-b border-zinc-200 hover:bg-zinc-50/50">
                                                <td className="px-4 py-3 text-zinc-900">{item?.prodotto}</td>
                                                <td className="px-4 py-3 text-zinc-600">{item?.costo} €</td>
                                                <td className="px-4 py-3 text-zinc-600">{item?.prezzo_staff} €</td>
                                                <td className="px-4 py-3 text-zinc-600">{item?.prezzo_clienti} €</td>
                                                <td className="px-4 py-3 text-center">
                                                    <input 
                                                        type="checkbox" 
                                                        onChange={(e) => {
                                                            if (e.target.checked) {
                                                                setSelectedProdotti([...selectedProdotti, item.id])
                                                            }
                                                            else {
                                                                setSelectedProdotti(selectedProdotti.filter(i => i != item.id))
                                                            }
                                                        }}
                                                        className="w-4 h-4 accent-yellow-400 rounded cursor-pointer"
                                                    />
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        {/* Footer */}
                        <div className="flex items-center justify-between gap-3 p-6 border-t border-zinc-200">
                            <div className="text-sm text-zinc-600">
                                <span className="font-semibold text-zinc-900">{selectedProdotti.length}</span> prodotti selezionati
                            </div>
                            <div className="flex gap-3">
                                <button 
                                    type="button"
                                    onClick={() => setVisible(false)}
                                    className="px-5 py-2.5 text-sm font-semibold text-zinc-700 bg-zinc-100 hover:bg-zinc-200 rounded-xl transition-all"
                                >
                                    Annulla
                                </button>
                                <button 
                                    type="button"
                                    onClick={() => addRow()}
                                    className="inline-flex items-center gap-2 px-5 py-2.5 text-sm font-semibold text-zinc-900 bg-yellow-400 hover:bg-yellow-500 rounded-xl shadow-sm hover:shadow transition-all"
                                >
                                    <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                                        <path fillRule="evenodd" d="M10 5a1 1 0 011 1v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3H6a1 1 0 110-2h3V6a1 1 0 011-1z" clipRule="evenodd"></path>
                                    </svg>
                                    Aggiungi Prodotti
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
}

export default ModalSelezionaProdotto;
